import axios from 'axios'
import store from '../index'
import { make } from 'vuex-pathify'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import { formatDate } from '@/util/formatters'

const defaultResumo = () => ({
  usuariosAtivos: 0,
  usuariosInativos: 0,
  administradores: 0,
  semAcesso30Dias: 0,
})

const state = {
  user: {},

  users: {
    data: [],
    count: 0,
    limit: 50,
  },

  resumo: defaultResumo(),

  permissions: [],

  userStats: {
    data: {},
    loading: false,
    dialog: false,
  },

  filter: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ['name'],
    sortDesc: [false],
  },

  type: 'add',
  loading: false,
  dialog: false,

  dark: false,
  drawer: {
    image: 0,
    gradient: 0,
    mini: false,
  },
  gradients: [
    'rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)',
    'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)',
    'rgba(244, 67, 54, .8), rgba(244, 67, 54, .8)',
  ],
  images: [
    'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg',
    'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-2.jpg',
    'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-3.jpg',
    'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-4.jpg',
  ],
  notifications: [],
  rtl: false,
}

const mutations = make.mutations(state)

const actions = {
  add: ({ state }) => {
    state.user = {
      permissions: [],

      active: true,
      admin: false,
      companyId: store.get('authStore@currentCompany').id,
    }
    state.type = 'add'
    state.dialog = true

    store.dispatch('userStore/getPermissions')
  },

  edit: ({ state }, id) => {
    state.loading = true
    store.dispatch('userStore/getById', id)
      .then(res => {
        state.user = res.data

        state.type = 'edit'
        state.dialog = true

        // format data
        state.user.birthDate = state.user.birthDate ? formatDate(new Date(res.data.birthDate).toISOString().substr(0, 10)) : null
        store.dispatch('userStore/getPermissions')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  view: ({ state }, id) => {
    state.loading = true
    store.dispatch('userStore/getById', id)
      .then(res => {
        state.user = res.data

        state.type = 'view'
        state.dialog = true

        // format data
        state.user.birthDate = state.user.birthDate ? formatDate(new Date(res.data.birthDate).toISOString().substr(0, 10)) : null
        store.dispatch('userStore/getPermissions')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  showUserStats: ({ state }, id) => {
    state.userStats.loading = true
    return axios
      .get(`${process.env.VUE_APP_API_URL}/user-stats/${id}`)
      .then(res => {
        state.userStats.data = res.data
        state.userStats.dialog = true

        // format data
        state.userStats.data.activeAndInactives =
          `${state.userStats.data.activeCustomersCount} x ${state.userStats.data.inactiveCustomersCount}`
      })
      .catch(showError)
      .finally(() => (state.userStats.loading = false))
  },

  save: ({ state, dispatch }, user) => {
    const id = user.id
    const method = id ? 'put' : 'post'

    state.loading = true
    const payload = { ...user }
    delete payload.imgUrl
    delete payload.imgPreview
    return axios[method](`${process.env.VUE_APP_API_URL}/user/${id || ''}`, payload)
      .then((res) => {
        delete user.password
        delete user.confirmPassword

        if (user.id && user.id === store.get('authStore@currentUser').id) {
          dispatch('updateCurrentUser', user)
        }

        state.dialog = false
        store.dispatch('userStore/get')
        showSuccess('Usuário salvo com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  updateCurrentUser: (context, user) => {
    const currentUser = store.get('authStore@currentUser')

    if (String(user.id) !== String(currentUser.id)) {
      return
    }
    const hasImg = Object.prototype.hasOwnProperty.call(user, 'img')
    const hasImgUrl = Object.prototype.hasOwnProperty.call(user, 'imgUrl')
    const resolvedImg = hasImg ? user.img : currentUser.img
    const resolvedImgUrl = hasImgUrl ? user.imgUrl : currentUser.imgUrl

    // Update CurrentUser
    currentUser.img = resolvedImg
    currentUser.imgUrl = resolvedImgUrl
    currentUser.receiveNotifications = Boolean(user.receiveNotifications)
    currentUser.name = user.name
    currentUser.cpf = user.cpf
    currentUser.phone = user.phone
    currentUser.email = user.email
    currentUser.useDarkMode = user.useDarkMode
    currentUser.useMiniMenu = user.useMiniMenu
    currentUser.colorSys = user.colorSys

    store.commit('authStore/updateUser', currentUser)
    store.dispatch('authStore/setUserConfig', currentUser)
  },

  getPermissions: async ({ state }) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/permission`)
      .then(res => {
        state.permissions = res.data
        return res
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  get: async ({ state }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/user?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.users = res.data
        state.resumo = res.data.resumo || defaultResumo()
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getById: (context, id) => axios.get(`${process.env.VUE_APP_API_URL}/user/${id}`).catch(showError),

  remove: ({ state }, id) => {
    const currentUser = store.get('authStore@currentUser')

    if (String(id) === String(currentUser.id)) {
      return showError('Não é possível excluir a si mesmo, consulte a documentação')
    }

    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/user/${id}`)
      .then(_ => {
        store.dispatch('userStore/get')
        showSuccess('Usuário excluído com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  setUsers: ({ state }, users) => {
    state.users.data = users
  },
}

const getters = {
  dark: (state, getters) => {
    return (
      state.dark ||
      getters.gradient.indexOf('255, 255, 255') === -1
    )
  },

  gradient: state => {
    return state.gradients[state.drawer.gradient]
  },

  image: state => {
    return state.drawer.image === '' ? state.drawer.image : state.images[state.drawer.image]
  },

  getById: state => id => {
    return state.users.data.find((u) => String(u.id) === String(id))
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
